module.exports = __webpack_public_path__ + "img/icon-bind.836b7592.svg";